module.exports = __webpack_public_path__ + "static/media/kids_54.5719163f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_54.jpg
// module id = 5910
// module chunks = 0